/* eslint-disable default-case */
import React from 'react';
import { connect } from "react-redux";
import styles from './Settings.module.css';
import sourceTypeData from './sourceTypes';
import defaults from './defaults';
import counterTypes from './counterTypes';
import constants from '../../../../globalization';

class Settings extends React.Component<> {
    state = {
        activeCheckFilter: '',
        filterOptions: defaults.filterSources,
        orderTypes: [],
        sourceTypes: [],
        revenueTypes: [],
        orderTypeNotifications: [],
        sourceTypeNotifications: [],
        revenueTypeNotifications: [],
        notificationTypesList: [],
        orderTypesList: defaults.orderTypesList,
        revenueCenters: defaults.revenuesList,
        managerMode: false,
        counters: []

    };

    componentDidMount() {
        const { reduxProps, managerMode } = this.props;
        if (managerMode) {
            this.setState({
                managerMode: true,
            });
        }
        const { storeTypesPersist, notificationsTypesPersist, storeInfo } = reduxProps;
        const { orderTypes, revenueCenters: storeInfoCenters } = storeInfo.data;
        const { revenueCenters, orderTypesList } = this.state;
        this.state.counters = reduxProps.storeTypesPersist.data.counterTypes || [];

        this.setState({
            sourceTypes: storeTypesPersist.data.sourceTypes.slice() || [],
            orderTypes: storeTypesPersist.data.orderTypes.slice() || [],
            revenueTypes: storeTypesPersist.data.revenueTypes.slice() || [],
            activeCheckFilter: storeTypesPersist.data.activeCheckFilter || 'sourceType',
            notificationTypesList: storeTypesPersist.data.notificationTypes || [],
            sourceTypeNotifications: notificationsTypesPersist.data.sourceType.slice() || [],
            orderTypeNotifications: notificationsTypesPersist.data.orderType.slice() || [],
            revenueTypeNotifications: notificationsTypesPersist.data.revenueCenter.slice() || [],
            orderTypesList: orderTypesList.concat(orderTypes.map(ot => {
                return ot;
            })),
            revenueCenters: revenueCenters.concat(storeInfoCenters.map(rc => {
                return rc;
            }))
        });
    }

    getFiltersList = () => {
        const { activeCheckFilter, orderTypesList, revenueCenters } = this.state;
        let listData = [];
        switch (activeCheckFilter) {
            case 'sourceType': {
                listData = sourceTypeData;
                break;
            }
            case 'orderType': {
                listData = orderTypesList
                break;
            }
            case 'revenueCenter': {
                listData = revenueCenters;
                break;
            }
        }
        return listData;
    };

    getNotificationTypesList = () => {
        const {
            reduxProps: { storeInfo },
        } = this.props;
        const { managerMode } = this.state;
        const { notificationTypes } = storeInfo.data;
        let nTypes = defaults.nTypesList.concat(notificationTypes);
        if (!managerMode) {
            nTypes = nTypes.filter(type => type.id !== 14 && type.id !== 15);
        }
        return nTypes;
    }

    changeFilterType = icon => {
        const { filterOptions, activeCheckFilter } = this.state;
        this.setState({
            activeCheckFilter: activeCheckFilter !== icon.shortText ? icon.shortText : activeCheckFilter,
            filterOptions: filterOptions.map(f => {
                if (f.shortText === icon.shortText && !f.checked) {
                    return {
                        ...f,
                        checked: true,
                    };
                }
                return {
                    ...f,
                    checked: false,
                };
            }),
        });
    };

    isCheckFilterChecked = icon => {
        const { activeCheckFilter, orderTypes, sourceTypes, revenueTypes } = this.state;
        switch (activeCheckFilter) {
            case 'sourceType': {
                return sourceTypes.includes(icon.name);
            }
            case 'orderType': {
                return orderTypes.includes(icon.name);
            }
            case 'revenueCenter': {
                return revenueTypes.includes(icon.name);
            }
            default: {
                return false;
            }
        }
    };

    updateCheckFilters = icon => {
        const { name } = icon;
        const { activeCheckFilter, sourceTypes, orderTypes, revenueTypes, orderTypesList, revenueCenters } = this.state;
        let arr = [];
        let parentArr = [];
        let stateVar = '';
        switch (activeCheckFilter) {
            case 'sourceType': {
                arr = sourceTypes;
                parentArr = sourceTypeData;
                stateVar = 'sourceTypes';
                break;
            }
            case 'orderType': {
                arr = orderTypes;
                parentArr = orderTypesList;
                stateVar = 'orderTypes';
                break;
            }
            case 'revenueCenter': {
                arr = revenueTypes;
                parentArr = revenueCenters;
                stateVar = 'revenueTypes';
                break;
            }
        }
        const index = arr.findIndex(t => t === name);
        let temp = arr;
        if (index === -1) {
            if (name === 'All') {
                temp = parentArr.map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === 'All') {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (arr.includes('All')) {
                    const allIndex = arr.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ [stateVar]: temp });
    };

    isNotificationFilterChecked = icon => {
        const {
            activeCheckFilter,
            orderTypeNotifications,
            sourceTypeNotifications,
            revenueTypeNotifications,
        } = this.state;
        switch (activeCheckFilter) {
            case 'sourceType': {
                return sourceTypeNotifications.includes(icon.name);
            }
            case 'orderType': {
                return orderTypeNotifications.includes(icon.name);
            }
            case 'revenueCenter': {
                return revenueTypeNotifications.includes(icon.name);
            }
            default: {
                return false;
            }
        }
    }

    isNotificationFilterTypeChecked = n => {
        const { notificationTypesList } = this.state;
        return notificationTypesList.includes(n.name);
    };


    updateNotificaitonFilters = icon => {
        const { name } = icon;
        const { activeCheckFilter, sourceTypeNotifications, orderTypeNotifications, revenueTypeNotifications, orderTypesList, revenueCenters } = this.state;
        let arr = [];
        let parentArr = [];
        let stateVar = '';
        switch (activeCheckFilter) {
            case 'sourceType': {
                arr = sourceTypeNotifications;
                parentArr = sourceTypeData;
                stateVar = 'sourceTypeNotifications';
                break;
            }
            case 'orderType': {
                arr = orderTypeNotifications;
                parentArr = orderTypesList;
                stateVar = 'orderTypeNotifications';
                break;
            }
            case 'revenueCenter': {
                arr = revenueTypeNotifications;
                parentArr = revenueCenters;
                stateVar = 'revenueTypeNotifications';
                break;
            }
        }
        const index = arr.findIndex(t => t === name);
        let temp = arr;
        if (index === -1) {
            if (name === 'All') {
                temp = parentArr.map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === 'All') {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (arr.includes('All')) {
                    const allIndex = arr.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ [stateVar]: temp });
    };

    updateNotificationTypeFilters = (icon) => {
        const { name } = icon;
        const { notificationTypesList } = this.state;
        const {
            reduxProps: { storeInfo },
        } = this.props;
        const { notificationTypes } = storeInfo.data;
        const index = notificationTypesList.findIndex(t => t === name);
        let temp = notificationTypesList;
        if (index === -1) {
            if (name === 'All') {
                temp = defaults.nTypesList.concat(notificationTypes).map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === 'All') {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (notificationTypesList.includes('All')) {
                    const allIndex = notificationTypesList.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ notificationTypesList: temp });
    }

    saveFilterData = () => {
        const {
            sourceTypes,
            orderTypes,
            revenueTypes,
            activeCheckFilter,
            orderTypeNotifications,
            sourceTypeNotifications,
            revenueTypeNotifications,
            notificationTypesList,
            counters,
        } = this.state;
        const { setOrderType, onSaveFilter, setNotificationType, setCounterType } = this.props;
        setNotificationType && setNotificationType(notificationTypesList);

        switch (activeCheckFilter) {
            case 'sourceType': {
                setOrderType && setOrderType(sourceTypes);
                break;
            }
            case 'orderType': {
                setOrderType && setOrderType(orderTypes);
                break;
            }
            case 'revenueCenter': {
                setOrderType && setOrderType(revenueTypes);
                break;
            }
        }
        setCounterType(counters)
        onSaveFilter && onSaveFilter(activeCheckFilter, orderTypes, sourceTypes, revenueTypes, orderTypeNotifications, sourceTypeNotifications, revenueTypeNotifications, notificationTypesList, counters);
    }

    isFilterOptionChecked = opt => {
        const { activeCheckFilter } = this.state;
        return activeCheckFilter === opt.shortText;
    }

    isCounterFilterChecked = counter => {
        const { counters } = this.state;
        return counters.includes(counter.name);
    };

    getHideCounters = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Hide Counters</span>
                <div className={styles.filterWrapper}>
                    {counterTypes.map(fo => {
                        return (
                            this.isCounterFilterChecked(fo) ?
                                <div key={`checked-counter-${fo.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateCounterFilters(fo)}>
                                    <span className={styles.checkboxLableChecked}>{fo.name}</span>
                                </div>
                                :
                                <div key={`uncheckd-counter-${fo.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateCounterFilters(fo)}>
                                    <span className={styles.checkboxLable}>{fo.name}</span>
                                </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    updateCounterFilters = (icon) => {
        const { updateHideCounter } = this.props;
        const { name } = icon;
        const { counters } = this.state;
        const index = counters.findIndex(t => t === name);
        let temp = counters;
        if (index === -1) {
            console.debug('pushing', name);
            if (name === constants.orderTypeAll) {
                temp = counterTypes.map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === constants.orderTypeAll) {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (counters.includes('All')) {
                    const allIndex = counters.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ counters: temp });

    };
    getFilterSoueces = (filterOptions) => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Filter Sources</span>
                <div className={styles.filterWrapper}>
                    {filterOptions.map(fo => {
                        return (
                            this.isFilterOptionChecked(fo) ?
                                <div key={`filter-${fo.shortText}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.changeFilterType(fo)}>
                                    <span className={styles.checkboxLableChecked}>{fo.name}</span>
                                </div>
                                :
                                <div key={`filter-${fo.shortText}`} className={styles.checkBoxWrapper} onClick={() => this.changeFilterType(fo)}>
                                    <span className={styles.checkboxLable}>{fo.name}</span>
                                </div>

                        )
                    })}
                </div>
            </div>
        )
    }
    getChecks = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Checks</span>
                <div className={styles.filterWrapper}>
                    {this.getFiltersList().map(f => {
                        return (
                            this.isCheckFilterChecked(f) ?
                                (<div key={`checkfilter-${f.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateCheckFilters(f)}>
                                    <span className={styles.checkboxLableChecked}>{f.name}</span>
                                </div>) :
                                (<div key={`checkfilter-${f.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateCheckFilters(f)}>
                                    <span className={styles.checkboxLable}>{f.name}</span>
                                </div>)
                        )
                    })}
                </div>
            </div>
        )
    }

    getNotifications = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Notifications</span>
                <div className={styles.filterWrapper}>
                    {this.getFiltersList().map(f => {
                        return (
                            this.isNotificationFilterChecked(f) ?
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateNotificaitonFilters(f)}>
                                    <span className={styles.checkboxLableChecked}>{f.name}</span>
                                </div>)
                                :
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateNotificaitonFilters(f)}>
                                    <span className={styles.checkboxLable}>{f.name}</span>
                                </div>)
                        )
                    })}
                </div>
            </div>
        )
    }

    getNotificationsFilter = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Notifications Filters</span>
                <div className={styles.filterWrapper}>
                    {this.getNotificationTypesList().map(f => {
                        return (
                            this.isNotificationFilterTypeChecked(f) ?
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateNotificationTypeFilters(f)}>
                                    <span className={styles.checkboxLableChecked}>{f.name}</span>
                                </div>)
                                :
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateNotificationTypeFilters(f)}>
                                    <span className={styles.checkboxLable}>{f.name}</span>
                                </div>)
                        )
                    })}
                </div>
            </div>
        )
    }

    render() {
        const { filterOptions } = this.state;
        const { onClose } = this.props;
        return (
            <div className={styles.container}>
                <div className={styles.heading}>FILTERS</div>
                <div className={styles.bodyContainer}>
                    {this.getHideCounters()}
                    {this.getFilterSoueces(filterOptions)}
                    {this.getChecks()}
                    {this.getNotifications()}
                    {this.getNotificationsFilter()}
                </div>
                <div className={styles.btnWrapper}>
                    <button className={styles.btns} onClick={onClose}>CANCEL</button>
                    <button className={styles.btns} onClick={this.saveFilterData}>SAVE</button>
                </div>
            </div>
        );
    }
};

const mapStateToProps = reduxProps => ({
    reduxProps,
});

export default connect(
    mapStateToProps,
    null,
)(Settings);